<!--
// app/components/layout/Toolbar.vue
-->
<script setup lang="ts">
import SocialIcons from "~/app/components/Shared/SocialIcons.vue";
import { useWebContext } from "~/app/composables/webContext";
import { useCompetitionStore } from "~/app/stores/competitionStore";
import { useWebappStore } from "~/app/stores/webappStore";

const { region } = useCompetitionStore();
const { webContext } = useWebContext();
const webappStore = useWebappStore();

const socialProfiles = {
  twitter: region?.social?.find(s => s.name === "twitter")?.url,
  discord: region?.social?.find(s => s.name === "discord")?.url,
  instagram: region?.social?.find(s => s.name === "instagram")?.url,
  tiktok: region?.social?.find(s => s.name === "tiktok")?.url,
  youtube: region?.social?.find(s => s.name === "youtube")?.url,
  facebook: region?.social?.find(s => s.name === "facebook")?.url,
  kick: region?.social?.find(s => s.name === "kick")?.url,
};
</script>

<template>
  <div
    id="toolbar"
    :class="[
      'bg-black justify-end pl-[152px] rtl:pr-[152px] rtl:pl-6 pr-6 text-white py-2 hidden min-h-[29px] lg:flex',
    ]"
    @mouseover="webappStore.hoveringMegaMenu = false"
  >
    <social-icons :social-profiles="socialProfiles" width="13" height="13"></social-icons>
  </div>
</template>

<style scoped></style>
